import { PdpState } from '@ff-os/pdp-shared-redux/store';
import { scenePlugins } from '@ff-os/pdp-shared-registry/index';

export const setStartupProjectFromScene = (state?: PdpState): PdpState | undefined => {

    if (!state) {
        return state;
    }

    const plugin = scenePlugins.require(state.scene.pluginId);
    const project = plugin.project.initialize(state.scene.project);

    const isContentFirst = state.scene?.options?.contentFirst;

    if (isContentFirst) {

        const allVariables = Object.values(project.variables?.entities || {}) as Array<{ id: string; pinned?: boolean }>;
        const pinnedVariables = allVariables.filter(v => v?.pinned);
        const pinnedVariableIds = pinnedVariables.map(v => v.id);

        const pinnedVariableEntities: Record<string, any> = {};
        const pinnedInputEntities: Record<string, any> = {};

        for (const v of pinnedVariables) {
            pinnedVariableEntities[v.id] = v;
            if (project.inputs?.entities?.[v.id]) {
                pinnedInputEntities[v.id] = project.inputs.entities[v.id];
            }
        }

        return {
            ...state,
            project: {
                ...project,
                inputs: { ids: Object.keys(pinnedInputEntities), entities: pinnedInputEntities },
                variables: { ids: pinnedVariableIds, entities: pinnedVariableEntities }
            }
        };
    }

    return {
        ...state,
        project: project
    };
};